export const FAST_MOVE_SPEED = 250;
export const UNIT_OFFSET = 8;
